"use client";

import { useEffect, useMemo, useState } from "react";
import BaseModal from "./BaseModal";
import styles from "./BaseModal.module.css";
import { authClient } from "../../lib/auth-client";

let openChangePasswordModalRef: (() => void) | null = null;

export function showChangePasswordModal() {
  openChangePasswordModalRef?.();
}

export default function ChangePasswordModal() {
  const [open, setOpen] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    openChangePasswordModalRef = () => {
      setErrorMsg("");
      setOpen(true);
    };

    return () => {
      openChangePasswordModalRef = null;
    };
  }, []);

  const canSubmit = useMemo(() => {
    return (
      !!currentPassword &&
      !!newPassword &&
      !!confirmNewPassword &&
      newPassword === confirmNewPassword &&
      newPassword !== currentPassword
    );
  }, [currentPassword, newPassword, confirmNewPassword]);

  function closeModal() {
    setOpen(false);
    setLoading(false);
    setErrorMsg("");
    setCurrentPassword("");
    setNewPassword("");
    setConfirmNewPassword("");
  }

  async function handleSave() {
    if (!currentPassword || !newPassword || !confirmNewPassword) {
      setErrorMsg("Preencha todos os campos.");
      return;
    }

    if (newPassword.length < 8) {
      setErrorMsg("A nova senha deve ter pelo menos 8 caracteres.");
      return;
    }

    if (newPassword === currentPassword) {
      setErrorMsg("A nova senha deve ser diferente da senha atual.");
      return;
    }

    if (newPassword !== confirmNewPassword) {
      setErrorMsg("A confirmação não confere com a nova senha.");
      return;
    }

    setLoading(true);
    setErrorMsg("");

    const result = await authClient.changePassword({
      currentPassword,
      newPassword,
      revokeOtherSessions: true,
    });

    if (result.error) {
      setErrorMsg(result.error.message || "Erro ao alterar senha.");
      setLoading(false);
      return;
    }

    alert("Senha alterada com sucesso");
    closeModal();
  }

  return (
    <BaseModal
      open={open}
      title="Alterar senha"
      subtitle="Atualize sua senha de acesso"
      onCancel={closeModal}
    >
      <div className={styles.body}>
        <div className={styles.formGroup}>
          <label className={styles.label}>Senha atual</label>
          <input
            type="password"
            className={styles.input}
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            placeholder="********"
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label}>Nova senha</label>
          <input
            type="password"
            className={styles.input}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="mínimo 8 caracteres"
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label}>Confirmar nova senha</label>
          <input
            type="password"
            className={styles.input}
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            placeholder="repita a nova senha"
          />
        </div>

        {errorMsg ? (
          <p className={styles.errorMessage}>{errorMsg}</p>
        ) : null}

        <div className={styles.actions}>
          <button
            type="button"
            onClick={closeModal}
            className={`${styles.button} ${styles.buttonSecondary}`}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handleSave}
            className={`${styles.button} ${styles.buttonPrimary}`}
            disabled={loading || !canSubmit}
          >
            {loading ? "Salvando..." : "Alterar senha"}
          </button>
        </div>
      </div>
    </BaseModal>
  );
}
